import { MapFactProps } from '../../../components/map-fact';

export const facts: MapFactProps[] = [
  {
    aboveValue: `Groundwater and desalination water is stored in our dams`,
    position: 'top-left',
  },
  {
    aboveValue: `With less rain our catchments are drier, this means when it rains they soak up the water, so less water ends up in our dams.`,
    position: 'bottom-right',
  },
  {
    aboveValue: `WA was the first state in Australia to use desalination as a main public water source.`,
    position: 'top-right',
  },
  {
    aboveValue: `The energy used to provide desalinated water for a family of 4 for 1 day is the same as the energy needed run an air conditioner for 1 hr.`,
    position: 'bottom-left',
  },
  {
    aboveValue: `If you have a garden bore, you could be using up to 70% groundwater in your home.`,
    position: 'top-left',
  },
  {
    aboveValue: `Groundwater plays a vital role for Perth, it gives us the lakes, wetlands, bushland and urban trees that makes our city such an enjoyable place to live.`,
    position: 'bottom-right',
  },
  {
    aboveValue: `To protect lakes and wetlands, we are transferring our groundwater abstraction to less sensitive locations, including deeper aquifers.`,
    position: 'top-right',
  },
  {
    aboveValue: `Our groundwater replenishment scheme, introduced in 2012, produces enough water to supply 100,000 households.`,
    position: 'bottom-left',
  },
  {
    aboveValue: `Treated wastewater undergoes further advanced treatmment to meet Australian drinking water guidelines, before being recharged.`,
    position: 'top-right',
  },
];
